let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1OAIU")).then(() => parcelRequire('kNHg5'));